module.exports = __webpack_public_path__ + "media/images/recruitment/blog/blog-4-ba89b11db7fdba86c5eba6bef2ffaa30.jpg";